import {  makeStyles } from '@material-ui/core/styles';


export default makeStyles((theme) => ({

    Top:{
        marginTop:'120px',
        height:'300px',
        width:'1300px',
        borderRadius:'10px',
        justifyContent:'center',
        alignItems:'center'
    },
    Top2:{
        marginTop:'120px',
        height:'300px',
        width:'1300px',
        borderRadius:'10px',
        justifyContent:'center',
        alignItems:'center'
    },
    profile:{
        alignContent:'center',
        margin:'30px',
        height:'230px',
        width:'300px',
    },
    details:{
        marginTop:'40px',
        marginRight:'300px',
        fontSize:'40px',
        color:'#1e88e5'  
    },
    details2:{
        marginTop:'20px',
        fontSize:'20px',
        color:'#ab003c'  
    }
 
}))